export default{
    lab: "آزمایشگاه",
    date: "تاریخ",
    result: "توضیح",
}